import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { TenantService } from './tenant.service';

export function tenantInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.indexOf('/assets') === -1 && environment.tenant) {
    return next(req.clone({ setHeaders: { Tenant: environment.tenant } }));
  }

  const tenantService = inject(TenantService);

  if (!tenantService.isValidTenant()) {
    tenantService.redirectToMainSite();
  }

  return next(req);
}
